import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../../_services/dialog.service';
import { Venue } from '../../_models/Venue';
import { VenueService } from '../../_services/venue.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-venue-mangement',
  templateUrl: './venue-mangement.component.html',
  styleUrls: ['./venue-mangement.component.css']
})

export class VenueManagementComponent implements OnInit  {

  displayVenues: Venue[];
  allVenues: Venue[];

  loading = false;

  searchText = '';

  private filterName(name:string, searchQuery:string): boolean{
    return name.toLowerCase().includes(searchQuery.toLowerCase())
  }

  public search() {
    this.displayVenues = this.allVenues.filter(venue => this.filterName(venue.name, this.searchText))
  }

  constructor(
    private venueService: VenueService,
    private router: Router,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService
  ) {

  }

  ngOnInit() {
    this.loading = true;
    this.spinner.show();
    this.venueService.get().subscribe(venues => {
      venues.forEach(v => {
        v.venueGroups = [];
        v.venueSections.map(s => {
          v.venueGroups.push(...s.groups);
        });
        v.venueGroups = Array.from(new Set(v.venueGroups)).filter(g => g !== '');
      });
      this.displayVenues = venues;
      this.allVenues = venues;
      this.loading = false;
      this.spinner.hide();
    },
    err => {
      this.loading = false;
      this.spinner.hide();
    });
  }

  delete(object: any) {
      this.loading = true;
      this.spinner.show();
      this.venueService.delete(object.coreEngineObjectId).subscribe(() => {
        this.displayVenues.splice(this.displayVenues.indexOf(object), 1);
        this.loading = false;
        this.spinner.hide();
    });
  }

  public edit(id: number) {
    this.router.navigate([`/portal/venue/create`, id]);
  }

  public createNew() {
    this.router.navigate([`/portal/venue/create`]);
  }
}
